import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { SafeAreaView, View, Pressable, TextInput } from 'react-native'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
const queryClient = new QueryClient()
// Configuración twrnc
import tw from "../../styles/tailwind";
import configureStore from "../../store/configureStore";
const { store, persistor } = configureStore();

import { MaterialIcons } from '@expo/vector-icons';
import { useRoute } from '@react-navigation/native';
import Text from '../../components/Text';

import ValidadoIcon from '../../assets/icons/validado';
import RechazadoIcon from '../../assets/icons/rechazado';
import { setPagoTarjetaReportado } from '../../store/slices/pagosTarjeta';

export default function PagoError({navigation}) {
    const route = useRoute(); 
    const dispatch = useDispatch();
    const Contrato = useSelector(state => state.contratos);
    const urlPagoTarjeta = Contrato.contratos.url_pago_tarjeta;
    const { checkout_id, order_id, payment_status } = route.params;
    const noContrato = Contrato.contratos.numeroContrato;
    const idEmpresa = Contrato.contratos.idEmpresa;
    const idActivacion = Contrato.contratos.codigoActivacion;
    const idAdeudo = Contrato.contratos.idAdeudo;
    useEffect(() => {
         dispatch(setPagoTarjetaReportado(idEmpresa, idActivacion, idAdeudo, order_id));
     }, [dispatch, idEmpresa, idActivacion, idAdeudo, order_id]);

    return(
        <SafeAreaView style={tw`flex-1  items-center`}>
           <View style={[tw`w-full bg-encabezado border-b border-primary shadow-lg justify-center items-center`, { height: 350 }]}>
                <View style={[tw`items-center`]}>
                    <RechazadoIcon  width={100} height={100}/>
                    <Text style={tw`text-primary text-5xl mt-4 font-500`}>Pago Declinado</Text>
                </View>
            </View>
            <View style={tw`w-full p-6`}>
                <View style={tw`p-6 `}>
                    <Text style={tw`text-primaryText text-xl text-left mt-2`}>Algo salió mal al procesar el pago, puede reintentar o elegir otro método de pago.</Text>
                </View>
            </View>
            <View style={[tw`flex-1 justify-center `]}>
                        <Pressable style={tw`bg-white p-6 rounded-full border border-primary`} onPress={() => goToInicio()}>
                            <Text style={tw`text-center text-xl text-primary text-xl`}>Reintentar</Text>
                        </Pressable>
                        <Pressable style={tw`bg-primary p-6 rounded-full mt-4`} onPress={() => goToMetodoPago()}>
                            <Text style={tw`text-center text-xl  text-white text-xl`}>Cambiar método de pago</Text>
                        </Pressable>
                    </View>
        </SafeAreaView>
    );

    function goToInicio(){
        window.open(urlPagoTarjeta, '_blank');
    }
    function goToMetodoPago(){
        navigation.navigate('MetodoPagoScreen.Index');
    }
};